module.exports = __webpack_public_path__ + "img/smd-visualization.7e2c3f8c.png";